<p-toast role="status" aria-live="polite" aria-atomic="true"></p-toast>
<p-confirmDialog role="alertdialog" aria-modal="true"></p-confirmDialog>

<div class="questionnaires-registry-container">
  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard' }"
    >
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <section class="page-header" aria-labelledby="page-title">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-list-check header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-title">Gestione Questionari</h1>
          <p class="subtitle">Configurazione e monitoraggio dei questionari</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Custom Toolbar for Show Deleted Toggle -->
  <div class="custom-toolbar mb-4">
    <div class="flex justify-content-between align-items-center">
      <div class="flex align-items-center gap-2">
        <label for="showDeleted" class="text-sm font-medium text-700">Mostra Eliminati</label>
        <p-toggleSwitch
          inputId="showDeleted"
          [(ngModel)]="showDeleted"
          (onChange)="onShowDeletedChange()"
          [attr.aria-label]="'Mostra questionari eliminati'"
        />
      </div>
    </div>
  </div>

  <!-- Reusable Table Component -->
  <app-registry-table
    [title]="tableTitle"
    [icon]="tableIcon"
    [columns]="columns"
    [data]="data()"
    [loading]="loading()"
    [showClearFiltersButton]="true"
    [ignoreStatusChecks]="true"
    (onEditClick)="onEditClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onClearFilters)="onClearFilters()"
  />
</div>
